import {
  WEB_RADIO_PROFILES,
  applyChannel as applyUv17Channel,
  compareImages,
  createChirpImage as createUv17Image,
  extractImage as extractUv17Image,
  parseChannels as parseUv17Channels,
  readRadioWithTransport as readUv17,
  writeRadioWithTransport as writeUv17,
  type RadioProgress,
  type WebChannel,
  type WebRadioProfile,
} from './baofeng-web.ts'
import {
  CLASSIC_UV5R_PROFILES,
  applyClassicChannel,
  parseClassicChannels,
  readClassicRadioWithTransport,
  writeClassicRadioWithTransport,
  type UV5RProfile,
} from './uv5r-web.ts'
import {
  RT22_PROFILES,
  applyRT22Channel,
  parseRT22Channels,
  readRT22RadioWithTransport,
  normalizeRT22ImageForComparison,
  writeRT22RadioWithTransport,
  type RT22Profile,
} from './rt22-web.ts'
import {
  T18_PROFILES,
  applyT18Channel,
  parseT18Channels,
  readT18RadioWithTransport,
  writeT18RadioWithTransport,
  type T18Profile,
} from './t18-web.ts'
import {
  FT60_PROFILES,
  applyFT60Channel,
  parseFT60Channels,
  readFT60RadioWithTransport,
  writeFT60RadioWithTransport,
  type FT60Profile,
} from './ft60-web.ts'
import {
  YAESU_SC35_PROFILES,
  applySC35Channel,
  parseSC35Channels,
  readSC35RadioWithTransport,
  writeSC35RadioWithTransport,
  type YaesuSC35Profile,
} from './yaesu-sc35-web.ts'
import {
  VX170_PROFILES,
  applyVX170Channel,
  parseVX170Channels,
  readVX170RadioWithTransport,
  writeVX170RadioWithTransport,
  type VX170Profile,
} from './yaesu-vx170-web.ts'
import {
  RB15_PROFILES,
  applyRB15Channel,
  parseRB15Channels,
  readRB15RadioWithTransport,
  writeRB15RadioWithTransport,
  type RB15Profile,
} from './retevis-rb15-web.ts'
import {
  MXT295_PROFILES,
  applyMXT295Channel,
  mxt295ChannelLabel,
  parseMXT295Channels,
  readMXT295RadioWithTransport,
  writeMXT295RadioWithTransport,
  type MXT295Profile,
} from './midland-mxt295-web.ts'
import {
  H777_PROFILES,
  applyH777Channel,
  parseH777Channels,
  readH777RadioWithTransport,
  writeH777RadioWithTransport,
  type H777Profile,
} from './h777-web.ts'
import {
  BTECH_MOBILE_PROFILES,
  applyBTechMobileChannel,
  parseBTechMobileChannels,
  readBTechMobileRadioWithTransport,
  writeBTechMobileRadioWithTransport,
  type BTechMobileProfile,
} from './btech-mobile-web.ts'
import {
  RT21_PROFILES,
  applyRT21Channel,
  parseRT21Channels,
  readRT21RadioWithTransport,
  writeRT21RadioWithTransport,
  type RT21Profile,
} from './retevis-rt21-web.ts'
import {
  KENWOOD_60G_PROFILES,
  applyKenwood60GChannel,
  parseKenwood60GChannels,
  readKenwood60GRadioWithTransport,
  writeKenwood60GRadioWithTransport,
  type Kenwood60GProfile,
} from './kenwood-60g-web.ts'
import {
  TDH8_PROFILES,
  applyTDH8Channel,
  extractTDH8Image,
  parseTDH8Channels,
  readTDH8RadioWithTransport,
  writeTDH8RadioWithTransport,
  type TDH8Profile,
} from './tdh8-web.ts'
import {
  JC8810_PROFILES,
  applyJC8810Channel,
  parseJC8810Channels,
  readJC8810RadioWithTransport,
  writeJC8810RadioWithTransport,
  type JC8810Profile,
} from './mml-jc8810-web.ts'
import {
  GA510_PROFILES,
  applyGA510Channel,
  parseGA510Channels,
  readGA510RadioWithTransport,
  writeGA510RadioWithTransport,
  type GA510Profile,
} from './ga510-web.ts'
import {
  RT490_PROFILES,
  applyRT490Channel,
  parseRT490Channels,
  readRT490RadioWithTransport,
  writeRT490RadioWithTransport,
  type RT490Profile,
} from './rt490-web.ts'
import {
  BFT8_PROFILES,
  applyBFT8Channel,
  parseBFT8Channels,
  readBFT8RadioWithTransport,
  writeBFT8RadioWithTransport,
  type BFT8Profile,
} from './bf-t8-web.ts'
import {
  TH9000_PROFILES,
  applyTH9000Channel,
  parseTH9000Channels,
  readTH9000RadioWithTransport,
  writeTH9000RadioWithTransport,
  type TH9000Profile,
} from './th9000-web.ts'
import {
  FD268_PROFILES,
  applyFD268Channel,
  parseFD268Channels,
  readFD268RadioWithTransport,
  writeFD268RadioWithTransport,
  type FD268Profile,
} from './fd268-web.ts'
import {
  WP970I_PROFILES,
  applyWP970IChannel,
  parseWP970IChannels,
  readWP970IRadioWithTransport,
  writeWP970IRadioWithTransport,
  type WP970IProfile,
} from './wp970i-web.ts'
import {
  RT900_PROFILES,
  applyRT900Channel,
  parseRT900Channels,
  readRT900RadioWithTransport,
  writeRT900RadioWithTransport,
  type RT900Profile,
} from './rt900-web.ts'
import {
  ANYTONE_778_PROFILES,
  applyAnyTone778Channel,
  parseAnyTone778Channels,
  readAnyTone778RadioWithTransport,
  writeAnyTone778RadioWithTransport,
  type AnyTone778Profile,
} from './anytone778-web.ts'
import {
  ALINCO_DRX35_PROFILES,
  applyAlincoDRx35Channel,
  parseAlincoDRx35Channels,
  readAlincoDRx35RadioWithTransport,
  writeAlincoDRx35RadioWithTransport,
  type AlincoDRx35Profile,
} from './alinco-drx35-web.ts'
import {
  DR735T_PROFILES,
  applyDR735TChannel,
  parseDR735TChannels,
  readDR735TRadioWithTransport,
  writeDR735TRadioWithTransport,
  type DR735TProfile,
} from './alinco-dr735t-web.ts'
import {
  LEIXEN_PROFILES,
  applyLeixenChannel,
  parseLeixenChannels,
  readLeixenRadioWithTransport,
  writeLeixenRadioWithTransport,
  type LeixenProfile,
} from './leixen-web.ts'
import {
  KENWOOD_M60_PROFILES,
  applyKenwoodM60Channel,
  parseKenwoodM60Channels,
  readKenwoodM60RadioWithTransport,
  writeKenwoodM60RadioWithTransport,
  type KenwoodM60Profile,
} from './kenwood-m60-web.ts'
import {
  THUV88_PROFILES,
  applyTHUV88Channel,
  parseTHUV88Channels,
  readTHUV88RadioWithTransport,
  writeTHUV88RadioWithTransport,
  type THUV88Profile,
} from './thuv88-web.ts'
import {
  R2_PROFILES,
  applyR2Channel,
  parseR2Channels,
  readR2RadioWithTransport,
  writeR2RadioWithTransport,
  type R2Profile,
} from './radioddity-r2-web.ts'
import {
  FT7800_PROFILES,
  applyFT7800Channel,
  parseFT7800Channels,
  readFT7800RadioWithTransport,
  writeFT7800RadioWithTransport,
  type FT7800Profile,
} from './yaesu-ft7800-web.ts'
import {
  FTX800_PROFILES,
  applyFTx800Channel,
  parseFTx800Channels,
  readFTx800RadioWithTransport,
  writeFTx800RadioWithTransport,
  type FTx800Profile,
} from './yaesu-ft8800-web.ts'
import {
  TKX180_PROFILES,
  applyTKx180Channel,
  parseTKx180Channels,
  readTKx180RadioWithTransport,
  writeTKx180RadioWithTransport,
  type TKx180Profile,
} from './kenwood-tkx180-web.ts'
import {
  KENWOOD_P60_PROFILES,
  applyKenwoodP60Channel,
  parseKenwoodP60Channels,
  readKenwoodP60RadioWithTransport,
  writeKenwoodP60RadioWithTransport,
  type KenwoodP60Profile,
} from './kenwood-p60-web.ts'
import {
  TKX80_PROFILES,
  applyTKx80Channel,
  parseTKx80Channels,
  readTKx80RadioWithTransport,
  writeTKx80RadioWithTransport,
  type TKx80Profile,
} from './kenwood-tkx80-web.ts'
import {
  LT725UV_PROFILES,
  applyLT725UVChannel,
  parseLT725UVChannels,
  readLT725UVRadioWithTransport,
  writeLT725UVRadioWithTransport,
  type LT725UVProfile,
} from './lt725uv-web.ts'
import {
  KENWOOD_CAT_PROFILES,
  applyKenwoodCatChannel,
  parseKenwoodCatChannels,
  readKenwoodCatRadioWithTransport,
  writeKenwoodCatRadioWithTransport,
  type KenwoodCatProfile,
} from './kenwood-cat-web.ts'
import {
  ICOM_CIV_PROFILES,
  applyIcomCivChannel,
  parseIcomCivChannels,
  readIcomCivRadioWithTransport,
  writeIcomCivRadioWithTransport,
  type IcomCivProfile,
} from './icom-civ-web.ts'
import {
  ANYTONE_5888_PROFILES,
  applyAnyTone5888Channel,
  parseAnyTone5888Channels,
  readAnyTone5888RadioWithTransport,
  writeAnyTone5888RadioWithTransport,
  type AnyTone5888Profile,
} from './anytone-5888-web.ts'
import {
  TKX102_PROFILES,
  applyTKx102Channel,
  parseTKx102Channels,
  readTKx102RadioWithTransport,
  writeTKx102RadioWithTransport,
  type TKx102Profile,
} from './kenwood-tkx102-web.ts'
import {
  TKX140_PROFILES,
  applyTKx140Channel,
  parseTKx140Channels,
  readTKx140RadioWithTransport,
  writeTKx140RadioWithTransport,
  type TKx140Profile,
} from './kenwood-tkx140-web.ts'
import {
  TKX160_PROFILES,
  applyTKx160Channel,
  parseTKx160Channels,
  readTKx160RadioWithTransport,
  writeTKx160RadioWithTransport,
  type TKx160Profile,
} from './kenwood-tkx160-web.ts'
import {
  WOUXUN_CLASSIC_PROFILES,
  applyWouxunClassicChannel,
  parseWouxunClassicChannels,
  readWouxunClassicRadioWithTransport,
  writeWouxunClassicRadioWithTransport,
  type WouxunClassicProfile,
} from './wouxun-classic-web.ts'
import {
  KG935G_PROFILES,
  applyKG935GChannel,
  parseKG935GChannels,
  readKG935GRadioWithTransport,
  writeKG935GRadioWithTransport,
  type KG935GProfile,
} from './wouxun-kg935g-web.ts'
import {
  KGUV9D_PROFILES,
  applyKGUV9DChannel,
  parseKGUV9DChannels,
  readKGUV9DRadioWithTransport,
  writeKGUV9DRadioWithTransport,
  type KGUV9DProfile,
} from './wouxun-kguv9d-web.ts'
import {
  GM30_PROFILES,
  applyGM30Channel,
  parseGM30Channels,
  readGM30RadioWithTransport,
  writeGM30RadioWithTransport,
  type GM30Profile,
} from './radioddity-gm30-web.ts'
import {
  UVK5_PROFILES,
  applyUVK5Channel,
  parseUVK5Channels,
  readUVK5RadioWithTransport,
  writeUVK5RadioWithTransport,
  type UVK5Profile,
} from './uvk5-web.ts'
import {
  RA25_PROFILES,
  applyRA25Channel,
  parseRA25Channels,
  readRA25RadioWithTransport,
  writeRA25RadioWithTransport,
  type RA25Profile,
} from './retevis-ra25-web.ts'
import {
  RT1_PROFILES,
  applyRT1Channel,
  parseRT1Channels,
  readRT1RadioWithTransport,
  writeRT1RadioWithTransport,
  type RT1Profile,
} from './retevis-rt1-web.ts'
import {
  RT21H_PROFILES,
  applyRT21HChannel,
  parseRT21HChannels,
  readRT21HRadioWithTransport,
  writeRT21HRadioWithTransport,
  type RT21HProfile,
} from './retevis-rt21h-web.ts'
import {
  RT23_PROFILES,
  applyRT23Channel,
  parseRT23Channels,
  readRT23RadioWithTransport,
  writeRT23RadioWithTransport,
  type RT23Profile,
} from './retevis-rt23-web.ts'
import {
  RT87_PROFILES,
  applyRT87Channel,
  parseRT87Channels,
  readRT87RadioWithTransport,
  writeRT87RadioWithTransport,
  type RT87Profile,
} from './retevis-rt87-web.ts'
import {
  RT97S_PROFILES,
  applyRT97SChannel,
  parseRT97SChannels,
  readRT97SRadioWithTransport,
  writeRT97SRadioWithTransport,
  type RT97SProfile,
} from './retevis-rt97s-web.ts'
import {
  RB17P_PROFILES,
  applyRB17PChannel,
  parseRB17PChannels,
  readRB17PRadioWithTransport,
  writeRB17PRadioWithTransport,
  type RB17PProfile,
} from './retevis-rb17p-web.ts'
import {
  RH5RV2_PROFILES,
  applyRH5RV2Channel,
  parseRH5RV2Channels,
  readRH5RV2RadioWithTransport,
  writeRH5RV2RadioWithTransport,
  type RH5RV2Profile,
} from './rugged-rh5rv2-web.ts'
import {
  FT817_PROFILES,
  applyFT817Channel,
  parseFT817Channels,
  readFT817RadioWithTransport,
  writeFT817RadioWithTransport,
  type FT817Profile,
} from './yaesu-ft817-web.ts'
import {
  BAOFENG_DIGITAL_PROFILES,
  applyBaofengDigitalChannel,
  parseBaofengDigitalChannels,
  readBaofengDigitalRadioWithTransport,
  writeBaofengDigitalRadioWithTransport,
  type BaofengDigitalProfile,
} from './baofeng-digital-web.ts'
import {
  BAOFENG_DM32UV_PROFILES,
  applyDM32UVChannel,
  parseDM32UVChannels,
  readBaofengDM32UVRadioWithTransport,
  writeBaofengDM32UVRadioWithTransport,
  type BaofengDM32UVProfile,
} from './baofeng-dm32uv-web.ts'
import {
  TID_HID_PROFILES,
  applyTIDHidChannel,
  parseTIDHidChannels,
  readTIDHidRadioWithTransport,
  writeTIDHidRadioWithTransport,
  type TIDHidProfile,
} from './tid-hid-web.ts'
import {
  BAOFENG_COMMON_PROFILES,
  applyBaofengCommonChannel,
  parseBaofengCommonChannels,
  readBaofengCommonRadioWithTransport,
  writeBaofengCommonRadioWithTransport,
  type BaofengCommonProfile,
} from './baofeng-common-web.ts'
import {
  UVB5_PROFILES,
  applyUVB5Channel,
  parseUVB5Channels,
  readUVB5RadioWithTransport,
  writeUVB5RadioWithTransport,
  type UVB5Profile,
} from './baofeng-uvb5-web.ts'
import {
  FT2D_PROFILES,
  applyFT2DChannel,
  parseFT2DChannels,
  readFT2DRadioWithTransport,
  writeFT2DRadioWithTransport,
  type FT2DProfile,
} from './yaesu-ft2d-web.ts'
import {
  TH7800_PROFILES,
  applyTH7800Channel,
  parseTH7800Channels,
  readTH7800RadioWithTransport,
  writeTH7800RadioWithTransport,
  type TH7800Profile,
} from './tyt-th7800-web.ts'
import {
  THUVF8D_PROFILES,
  applyTHUVF8DChannel,
  parseTHUVF8DChannels,
  readTHUVF8DRadioWithTransport,
  writeTHUVF8DRadioWithTransport,
  type THUVF8DProfile,
} from './tyt-thuvf8d-web.ts'
import { vendors } from './supported-radios.ts'
import type { RadioTransport } from './web-serial.ts'

export type BrowserRadioProfile =
  | WebRadioProfile
  | UV5RProfile
  | RT22Profile
  | T18Profile
  | FT60Profile
  | YaesuSC35Profile
  | VX170Profile
  | RB15Profile
  | MXT295Profile
  | H777Profile
  | BTechMobileProfile
  | RT21Profile
  | Kenwood60GProfile
  | TDH8Profile
  | JC8810Profile
  | GA510Profile
  | RT490Profile
  | BFT8Profile
  | TH9000Profile
  | FD268Profile
  | WP970IProfile
  | RT900Profile
  | AnyTone778Profile
  | AlincoDRx35Profile
  | DR735TProfile
  | LeixenProfile
  | KenwoodM60Profile
  | THUV88Profile
  | R2Profile
  | FT7800Profile
  | FTx800Profile
  | TKx180Profile
  | KenwoodP60Profile
  | TKx80Profile
  | LT725UVProfile
  | KenwoodCatProfile
  | IcomCivProfile
  | AnyTone5888Profile
  | TKx102Profile
  | TKx140Profile
  | TKx160Profile
  | WouxunClassicProfile
  | KG935GProfile
  | KGUV9DProfile
  | GM30Profile
  | UVK5Profile
  | RA25Profile
  | RT1Profile
  | RT21HProfile
  | RT23Profile
  | RT87Profile
  | RT97SProfile
  | RB17PProfile
  | RH5RV2Profile
  | FT817Profile
  | BaofengDigitalProfile
  | BaofengDM32UVProfile
  | TIDHidProfile
  | BaofengCommonProfile
  | UVB5Profile
  | FT2DProfile
  | TH7800Profile
  | THUVF8DProfile
export type {
  RadioProgress,
  WebChannel,
  WebRadioProfile,
  UV5RProfile,
  RT22Profile,
  T18Profile,
  FT60Profile,
  YaesuSC35Profile,
  VX170Profile,
  RB15Profile,
  MXT295Profile,
  H777Profile,
  BTechMobileProfile,
  RT21Profile,
  Kenwood60GProfile,
  TDH8Profile,
  JC8810Profile,
  GA510Profile,
  RT490Profile,
  BFT8Profile,
  TH9000Profile,
  FD268Profile,
  WP970IProfile,
  RT900Profile,
  AnyTone778Profile,
  AlincoDRx35Profile,
  DR735TProfile,
  LeixenProfile,
  KenwoodM60Profile,
  THUV88Profile,
  R2Profile,
  FT7800Profile,
  FTx800Profile,
  TKx180Profile,
  KenwoodP60Profile,
  TKx80Profile,
  LT725UVProfile,
  KenwoodCatProfile,
  IcomCivProfile,
  AnyTone5888Profile,
  TKx102Profile,
  TKx140Profile,
  TKx160Profile,
  WouxunClassicProfile,
  KG935GProfile,
  KGUV9DProfile,
  GM30Profile,
  UVK5Profile,
  RA25Profile,
  RT1Profile,
  RT21HProfile,
  RT23Profile,
  RT87Profile,
  RT97SProfile,
  RB17PProfile,
  RH5RV2Profile,
  FT817Profile,
  BaofengDigitalProfile,
  BaofengDM32UVProfile,
  TIDHidProfile,
  BaofengCommonProfile,
  UVB5Profile,
  FT2DProfile,
  TH7800Profile,
  THUVF8DProfile,
}

const profileByModel = new Map<string, BrowserRadioProfile>()
for (const profile of [
  ...WEB_RADIO_PROFILES,
  ...CLASSIC_UV5R_PROFILES,
  ...RT22_PROFILES,
  ...T18_PROFILES,
  ...FT60_PROFILES,
  ...YAESU_SC35_PROFILES,
  ...VX170_PROFILES,
  ...RB15_PROFILES,
  ...MXT295_PROFILES,
  ...H777_PROFILES,
  ...BTECH_MOBILE_PROFILES,
  ...RT21_PROFILES,
  ...KENWOOD_60G_PROFILES,
  ...TDH8_PROFILES,
  ...JC8810_PROFILES,
  ...GA510_PROFILES,
  ...RT490_PROFILES,
  ...BFT8_PROFILES,
  ...TH9000_PROFILES,
  ...FD268_PROFILES,
  ...WP970I_PROFILES,
  ...RT900_PROFILES,
  ...ANYTONE_778_PROFILES,
  ...ALINCO_DRX35_PROFILES,
  ...DR735T_PROFILES,
  ...LEIXEN_PROFILES,
  ...KENWOOD_M60_PROFILES,
  ...THUV88_PROFILES,
  ...R2_PROFILES,
  ...FT7800_PROFILES,
  ...FTX800_PROFILES,
  ...TKX180_PROFILES,
  ...KENWOOD_P60_PROFILES,
  ...TKX80_PROFILES,
  ...LT725UV_PROFILES,
  ...KENWOOD_CAT_PROFILES,
  ...ICOM_CIV_PROFILES,
  ...ANYTONE_5888_PROFILES,
  ...TKX102_PROFILES,
  ...TKX140_PROFILES,
  ...TKX160_PROFILES,
  ...WOUXUN_CLASSIC_PROFILES,
  ...KG935G_PROFILES,
  ...KGUV9D_PROFILES,
  ...GM30_PROFILES,
  ...UVK5_PROFILES,
  ...RA25_PROFILES,
  ...RT1_PROFILES,
  ...RT21H_PROFILES,
  ...RT23_PROFILES,
  ...RT87_PROFILES,
  ...RT97S_PROFILES,
  ...RB17P_PROFILES,
  ...RH5RV2_PROFILES,
  ...FT817_PROFILES,
  ...BAOFENG_DIGITAL_PROFILES,
  ...BAOFENG_DM32UV_PROFILES,
  ...TID_HID_PROFILES,
  ...BAOFENG_COMMON_PROFILES,
  ...UVB5_PROFILES,
  ...FT2D_PROFILES,
  ...TH7800_PROFILES,
  ...THUVF8D_PROFILES,
] as BrowserRadioProfile[]) {
  const key = `${profile.vendor}|${profile.model}`.toLowerCase()
  if (!profileByModel.has(key)) profileByModel.set(key, profile)
}

function browserModelKey(value: string): string {
  return value
    .toLowerCase()
    .replace(/\s*\(experimental\)\s*$/, '')
    .replace(/\s*\*$/, '')
    .replace(/[\s/_-]+/g, '')
}

function browserAliasSlug(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

function aliasBaseProfile(target: string): BrowserRadioProfile | null {
  const normalizedTarget = browserModelKey(target)
  const vendorNames = new Set(
    [...profileByModel.values()].map((profile) => profile.vendor.toLowerCase()),
  )
  const words = target.split(/\s+/)
  const explicitVendor =
    words.length > 1 && vendorNames.has(words[0].toLowerCase())
      ? words.shift()?.toLowerCase()
      : null
  const targetModel = browserModelKey(words.join(' '))
  const candidates = [...profileByModel.values()].filter(
    (profile) =>
      browserModelKey(profile.model) === targetModel ||
      browserModelKey(`${profile.vendor} ${profile.model}`) === normalizedTarget,
  )
  return (
    candidates.find(
      (profile) => explicitVendor && profile.vendor.toLowerCase() === explicitVendor,
    ) ??
    candidates[0] ??
    null
  )
}

export const BROWSER_RADIO_ALIAS_PROFILES: BrowserRadioProfile[] = []
const aliasProfileIds = new Set(
  [...profileByModel.values()].map((profile) => profile.id),
)
for (const vendor of vendors) {
  for (const model of vendor.models) {
    if (profileByModel.has(`${vendor.name}|${model}`.toLowerCase())) continue
    const matches = [...model.matchAll(/\([^)]*?\buse ([^)]+)\)/gi)]
    if (!matches.length) continue
    const base = aliasBaseProfile(matches.at(-1)?.[1] ?? '')
    if (!base) continue
    const aliasStem = `alias-${browserAliasSlug(vendor.name)}-${browserAliasSlug(model)}-${base.id}`
    let aliasId = aliasStem
    let aliasSequence = 2
    while (aliasProfileIds.has(aliasId)) {
      aliasId = `${aliasStem}-${aliasSequence}`
      aliasSequence += 1
    }
    aliasProfileIds.add(aliasId)
    const alias = {
      ...base,
      id: aliasId,
      vendor: vendor.name,
      model,
      summary: `Catalog alias using the verified ${base.vendor} ${base.model} browser protocol.`,
      tags: [
        ...base.tags.filter(
          (tag) => !['Read + write', 'Experimental'].includes(tag),
        ),
        'Catalog alias',
        'Experimental',
        'Read + write',
      ],
    } as BrowserRadioProfile
    BROWSER_RADIO_ALIAS_PROFILES.push(alias)
    profileByModel.set(`${alias.vendor}|${alias.model}`.toLowerCase(), alias)
  }
}

export const BROWSER_RADIO_PROFILES: readonly BrowserRadioProfile[] = [
  ...profileByModel.values(),
]

type BrowserRadioGroupInput = {
  label: string
  profiles: readonly BrowserRadioProfile[]
}

export type BrowserRadioGroup = {
  label: string
  manufacturer: string
  profiles: BrowserRadioProfile[]
}

export function orderBrowserRadioGroups(
  groups: readonly BrowserRadioGroupInput[],
): BrowserRadioGroup[] {
  const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base',
  })
  return groups
    .map((group) => {
      const profiles = [...group.profiles].sort(
        (left, right) =>
          collator.compare(left.vendor, right.vendor) ||
          collator.compare(left.model, right.model),
      )
      return {
        ...group,
        manufacturer: profiles[0]?.vendor ?? group.label,
        profiles,
      }
    })
    .filter((group) => group.profiles.length > 0)
    .sort(
      (left, right) =>
        collator.compare(left.manufacturer, right.manufacturer) ||
        collator.compare(left.label, right.label),
    )
}

const CHIRP_IMAGE_MARKER = Uint8Array.from([
  0x00, 0xff, 0x63, 0x68, 0x69, 0x72, 0x70, 0xee, 0x69, 0x6d, 0x67, 0x00, 0x01,
])

export function browserProfileById(id: string): BrowserRadioProfile {
  const profile = BROWSER_RADIO_PROFILES.find((candidate) => candidate.id === id)
  if (!profile) throw new Error(`Unknown web radio profile: ${id}`)
  return profile
}

export function browserParseChannels(
  image: Uint8Array,
  profile: BrowserRadioProfile,
): WebChannel[] {
  if (profile.protocol === 'uv5r') return parseClassicChannels(image, profile)
  if (profile.protocol === 'rt22') return parseRT22Channels(image, profile)
  if (profile.protocol === 't18') return parseT18Channels(image, profile)
  if (profile.protocol === 'ft60') return parseFT60Channels(image, profile)
  if (profile.protocol === 'sc35') return parseSC35Channels(image, profile)
  if (profile.protocol === 'vx170') return parseVX170Channels(image, profile)
  if (profile.protocol === 'rb15') return parseRB15Channels(image, profile)
  if (profile.protocol === 'mxt295') return parseMXT295Channels(image, profile)
  if (profile.protocol === 'h777') return parseH777Channels(image, profile)
  if (profile.protocol === 'btech') {
    return parseBTechMobileChannels(image, profile)
  }
  if (profile.protocol === 'rt21') return parseRT21Channels(image, profile)
  if (profile.protocol === 'kenwood60g') {
    return parseKenwood60GChannels(image, profile)
  }
  if (profile.protocol === 'tdh8') return parseTDH8Channels(image, profile)
  if (profile.protocol === 'jc8810') return parseJC8810Channels(image, profile)
  if (profile.protocol === 'ga510') return parseGA510Channels(image, profile)
  if (profile.protocol === 'rt490') return parseRT490Channels(image, profile)
  if (profile.protocol === 'bft8') return parseBFT8Channels(image, profile)
  if (profile.protocol === 'th9000') return parseTH9000Channels(image, profile)
  if (profile.protocol === 'fd268') return parseFD268Channels(image, profile)
  if (profile.protocol === 'wp970i') return parseWP970IChannels(image, profile)
  if (profile.protocol === 'rt900') return parseRT900Channels(image, profile)
  if (profile.protocol === 'anytone778') {
    return parseAnyTone778Channels(image, profile)
  }
  if (profile.protocol === 'alinco-drx35') {
    return parseAlincoDRx35Channels(image, profile)
  }
  if (profile.protocol === 'alinco-dr735t') {
    return parseDR735TChannels(image, profile)
  }
  if (profile.protocol === 'leixen') return parseLeixenChannels(image, profile)
  if (profile.protocol === 'kenwood-m60') {
    return parseKenwoodM60Channels(image, profile)
  }
  if (profile.protocol === 'thuv88') return parseTHUV88Channels(image, profile)
  if (profile.protocol === 'r2') return parseR2Channels(image, profile)
  if (profile.protocol === 'ft7800') return parseFT7800Channels(image, profile)
  if (profile.protocol === 'yaesu-ftx800') {
    return parseFTx800Channels(image, profile)
  }
  if (profile.protocol === 'kenwood-tkx180') {
    return parseTKx180Channels(image)
  }
  if (profile.protocol === 'kenwood-p60') {
    return parseKenwoodP60Channels(image, profile)
  }
  if (profile.protocol === 'kenwood-tkx80') {
    return parseTKx80Channels(image, profile)
  }
  if (profile.protocol === 'lt725uv') {
    return parseLT725UVChannels(image, profile)
  }
  if (profile.protocol === 'kenwood-cat') {
    return parseKenwoodCatChannels(image, profile)
  }
  if (profile.protocol === 'icom-civ') {
    return parseIcomCivChannels(image, profile)
  }
  if (profile.protocol === 'anytone5888') {
    return parseAnyTone5888Channels(image, profile)
  }
  if (profile.protocol === 'kenwood-tkx102') {
    return parseTKx102Channels(image, profile)
  }
  if (profile.protocol === 'kenwood-tkx140') {
    return parseTKx140Channels(image, profile)
  }
  if (profile.protocol === 'kenwood-tkx160') {
    return parseTKx160Channels(image, profile)
  }
  if (profile.protocol === 'wouxun-classic') {
    return parseWouxunClassicChannels(image, profile)
  }
  if (profile.protocol === 'wouxun-kg935g') {
    return parseKG935GChannels(image, profile)
  }
  if (profile.protocol === 'wouxun-kguv9d') {
    return parseKGUV9DChannels(image, profile)
  }
  if (profile.protocol === 'radioddity-gm30') {
    return parseGM30Channels(image, profile)
  }
  if (profile.protocol === 'uvk5') {
    return parseUVK5Channels(image, profile)
  }
  if (profile.protocol === 'retevis-ra25') {
    return parseRA25Channels(image, profile)
  }
  if (profile.protocol === 'retevis-rt1') {
    return parseRT1Channels(image, profile)
  }
  if (profile.protocol === 'retevis-rt21h') {
    return parseRT21HChannels(image, profile)
  }
  if (profile.protocol === 'retevis-rt23') {
    return parseRT23Channels(image, profile)
  }
  if (profile.protocol === 'retevis-rt87') {
    return parseRT87Channels(image, profile)
  }
  if (profile.protocol === 'retevis-rt97s') {
    return parseRT97SChannels(image, profile)
  }
  if (profile.protocol === 'retevis-rb17p') {
    return parseRB17PChannels(image, profile)
  }
  if (profile.protocol === 'rugged-rh5rv2') {
    return parseRH5RV2Channels(image, profile)
  }
  if (profile.protocol === 'yaesu-ft817') {
    return parseFT817Channels(image, profile)
  }
  if (profile.protocol === 'baofeng-digital') {
    return parseBaofengDigitalChannels(image, profile)
  }
  if (profile.protocol === 'baofeng-dm32uv') {
    return parseDM32UVChannels(image, profile)
  }
  if (profile.protocol === 'tid-hid') {
    return parseTIDHidChannels(image, profile)
  }
  if (profile.protocol === 'baofeng-common') {
    return parseBaofengCommonChannels(image, profile)
  }
  if (profile.protocol === 'baofeng-uvb5') {
    return parseUVB5Channels(image, profile)
  }
  if (profile.protocol === 'yaesu-ft2d') {
    return parseFT2DChannels(image, profile)
  }
  if (profile.protocol === 'tyt-th7800') {
    return parseTH7800Channels(image, profile)
  }
  if (profile.protocol === 'tyt-thuvf8d') {
    return parseTHUVF8DChannels(image, profile)
  }
  return parseUv17Channels(image, profile)
}

export function browserApplyChannel(
  image: Uint8Array,
  profile: BrowserRadioProfile,
  channel: WebChannel,
): void {
  if (profile.protocol === 'uv5r') {
    applyClassicChannel(image, profile, channel)
  } else if (profile.protocol === 'rt22') {
    applyRT22Channel(image, profile, channel)
  } else if (profile.protocol === 't18') {
    applyT18Channel(image, profile, channel)
  } else if (profile.protocol === 'ft60') {
    applyFT60Channel(image, profile, channel)
  } else if (profile.protocol === 'sc35') {
    applySC35Channel(image, profile, channel)
  } else if (profile.protocol === 'vx170') {
    applyVX170Channel(image, profile, channel)
  } else if (profile.protocol === 'rb15') {
    applyRB15Channel(image, profile, channel)
  } else if (profile.protocol === 'mxt295') {
    applyMXT295Channel(image, profile, channel)
  } else if (profile.protocol === 'h777') {
    applyH777Channel(image, profile, channel)
  } else if (profile.protocol === 'btech') {
    applyBTechMobileChannel(image, profile, channel)
  } else if (profile.protocol === 'rt21') {
    applyRT21Channel(image, profile, channel)
  } else if (profile.protocol === 'kenwood60g') {
    applyKenwood60GChannel(image, profile, channel)
  } else if (profile.protocol === 'tdh8') {
    applyTDH8Channel(image, profile, channel)
  } else if (profile.protocol === 'jc8810') {
    applyJC8810Channel(image, profile, channel)
  } else if (profile.protocol === 'ga510') {
    applyGA510Channel(image, profile, channel)
  } else if (profile.protocol === 'rt490') {
    applyRT490Channel(image, profile, channel)
  } else if (profile.protocol === 'bft8') {
    applyBFT8Channel(image, profile, channel)
  } else if (profile.protocol === 'th9000') {
    applyTH9000Channel(image, profile, channel)
  } else if (profile.protocol === 'fd268') {
    applyFD268Channel(image, profile, channel)
  } else if (profile.protocol === 'wp970i') {
    applyWP970IChannel(image, profile, channel)
  } else if (profile.protocol === 'rt900') {
    applyRT900Channel(image, profile, channel)
  } else if (profile.protocol === 'anytone778') {
    applyAnyTone778Channel(image, profile, channel)
  } else if (profile.protocol === 'alinco-drx35') {
    applyAlincoDRx35Channel(image, profile, channel)
  } else if (profile.protocol === 'alinco-dr735t') {
    applyDR735TChannel(image, profile, channel)
  } else if (profile.protocol === 'leixen') {
    applyLeixenChannel(image, profile, channel)
  } else if (profile.protocol === 'kenwood-m60') {
    applyKenwoodM60Channel(image, profile, channel)
  } else if (profile.protocol === 'thuv88') {
    applyTHUV88Channel(image, profile, channel)
  } else if (profile.protocol === 'r2') {
    applyR2Channel(image, profile, channel)
  } else if (profile.protocol === 'ft7800') {
    applyFT7800Channel(image, profile, channel)
  } else if (profile.protocol === 'yaesu-ftx800') {
    applyFTx800Channel(image, profile, channel)
  } else if (profile.protocol === 'kenwood-tkx180') {
    applyTKx180Channel(image, channel)
  } else if (profile.protocol === 'kenwood-p60') {
    applyKenwoodP60Channel(image, profile, channel)
  } else if (profile.protocol === 'kenwood-tkx80') {
    applyTKx80Channel(image, profile, channel)
  } else if (profile.protocol === 'lt725uv') {
    applyLT725UVChannel(image, profile, channel)
  } else if (profile.protocol === 'kenwood-cat') {
    applyKenwoodCatChannel(image, profile, channel)
  } else if (profile.protocol === 'icom-civ') {
    applyIcomCivChannel(image, profile, channel)
  } else if (profile.protocol === 'anytone5888') {
    applyAnyTone5888Channel(image, profile, channel)
  } else if (profile.protocol === 'kenwood-tkx102') {
    applyTKx102Channel(image, profile, channel)
  } else if (profile.protocol === 'kenwood-tkx140') {
    applyTKx140Channel(image, profile, channel)
  } else if (profile.protocol === 'kenwood-tkx160') {
    applyTKx160Channel(image, profile, channel)
  } else if (profile.protocol === 'wouxun-classic') {
    applyWouxunClassicChannel(image, profile, channel)
  } else if (profile.protocol === 'wouxun-kg935g') {
    applyKG935GChannel(image, profile, channel)
  } else if (profile.protocol === 'wouxun-kguv9d') {
    applyKGUV9DChannel(image, profile, channel)
  } else if (profile.protocol === 'radioddity-gm30') {
    applyGM30Channel(image, profile, channel)
  } else if (profile.protocol === 'uvk5') {
    applyUVK5Channel(image, profile, channel)
  } else if (profile.protocol === 'retevis-ra25') {
    applyRA25Channel(image, profile, channel)
  } else if (profile.protocol === 'retevis-rt1') {
    applyRT1Channel(image, profile, channel)
  } else if (profile.protocol === 'retevis-rt21h') {
    applyRT21HChannel(image, profile, channel)
  } else if (profile.protocol === 'retevis-rt23') {
    applyRT23Channel(image, profile, channel)
  } else if (profile.protocol === 'retevis-rt87') {
    applyRT87Channel(image, profile, channel)
  } else if (profile.protocol === 'retevis-rt97s') {
    applyRT97SChannel(image, profile, channel)
  } else if (profile.protocol === 'retevis-rb17p') {
    applyRB17PChannel(image, profile, channel)
  } else if (profile.protocol === 'rugged-rh5rv2') {
    applyRH5RV2Channel(image, profile, channel)
  } else if (profile.protocol === 'yaesu-ft817') {
    applyFT817Channel(image, profile, channel)
  } else if (profile.protocol === 'baofeng-digital') {
    applyBaofengDigitalChannel(image, profile, channel)
  } else if (profile.protocol === 'baofeng-dm32uv') {
    applyDM32UVChannel(image, profile, channel)
  } else if (profile.protocol === 'tid-hid') {
    applyTIDHidChannel(image, profile, channel)
  } else if (profile.protocol === 'baofeng-common') {
    applyBaofengCommonChannel(image, profile, channel)
  } else if (profile.protocol === 'baofeng-uvb5') {
    applyUVB5Channel(image, profile, channel)
  } else if (profile.protocol === 'yaesu-ft2d') {
    applyFT2DChannel(image, profile, channel)
  } else if (profile.protocol === 'tyt-th7800') {
    applyTH7800Channel(image, profile, channel)
  } else if (profile.protocol === 'tyt-thuvf8d') {
    applyTHUVF8DChannel(image, profile, channel)
  } else {
    applyUv17Channel(image, profile, channel)
  }
}

export async function browserReadRadio(
  profile: BrowserRadioProfile,
  transport: RadioTransport,
  onProgress?: (progress: RadioProgress) => void,
): Promise<{ image: Uint8Array; reportedModel: string }> {
  if (profile.protocol === 'uv5r') {
    return readClassicRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'rt22') {
    return readRT22RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 't18') {
    return readT18RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'ft60') {
    return readFT60RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'sc35') {
    return readSC35RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'vx170') {
    return readVX170RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'rb15') {
    return readRB15RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'mxt295') {
    return readMXT295RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'h777') {
    return readH777RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'btech') {
    return readBTechMobileRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'rt21') {
    return readRT21RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'kenwood60g') {
    return readKenwood60GRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'tdh8') {
    return readTDH8RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'jc8810') {
    return readJC8810RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'ga510') {
    return readGA510RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'rt490') {
    return readRT490RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'bft8') {
    return readBFT8RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'th9000') {
    return readTH9000RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'fd268') {
    return readFD268RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'wp970i') {
    return readWP970IRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'rt900') {
    return readRT900RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'anytone778') {
    return readAnyTone778RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'alinco-drx35') {
    return readAlincoDRx35RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'alinco-dr735t') {
    return readDR735TRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'leixen') {
    return readLeixenRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-m60') {
    return readKenwoodM60RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'thuv88') {
    return readTHUV88RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'r2') {
    return readR2RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'ft7800') {
    return readFT7800RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'yaesu-ftx800') {
    return readFTx800RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-tkx180') {
    return readTKx180RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-p60') {
    return readKenwoodP60RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-tkx80') {
    return readTKx80RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'lt725uv') {
    return readLT725UVRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-cat') {
    return readKenwoodCatRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'icom-civ') {
    return readIcomCivRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'anytone5888') {
    return readAnyTone5888RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-tkx102') {
    return readTKx102RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-tkx140') {
    return readTKx140RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-tkx160') {
    return readTKx160RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'wouxun-classic') {
    return readWouxunClassicRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'wouxun-kg935g') {
    return readKG935GRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'wouxun-kguv9d') {
    return readKGUV9DRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'radioddity-gm30') {
    return readGM30RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'uvk5') {
    return readUVK5RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'retevis-ra25') {
    return readRA25RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'retevis-rt1') {
    return readRT1RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'retevis-rt21h') {
    return readRT21HRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'retevis-rt23') {
    return readRT23RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'retevis-rt87') {
    return readRT87RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'retevis-rt97s') {
    return readRT97SRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'retevis-rb17p') {
    return readRB17PRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'rugged-rh5rv2') {
    return readRH5RV2RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'yaesu-ft817') {
    return readFT817RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'baofeng-digital') {
    return readBaofengDigitalRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'baofeng-dm32uv') {
    return readBaofengDM32UVRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'tid-hid') {
    return readTIDHidRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'baofeng-common') {
    return readBaofengCommonRadioWithTransport(
      profile,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'baofeng-uvb5') {
    return readUVB5RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'yaesu-ft2d') {
    return readFT2DRadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'tyt-th7800') {
    return readTH7800RadioWithTransport(profile, transport, onProgress)
  }
  if (profile.protocol === 'tyt-thuvf8d') {
    return readTHUVF8DRadioWithTransport(profile, transport, onProgress)
  }
  return readUv17(profile, transport, onProgress)
}

export async function browserWriteRadio(
  profile: BrowserRadioProfile,
  image: Uint8Array,
  transport: RadioTransport,
  onProgress?: (progress: RadioProgress) => void,
): Promise<void> {
  if (profile.protocol === 'uv5r') {
    return writeClassicRadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'rt22') {
    return writeRT22RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 't18') {
    return writeT18RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'ft60') {
    return writeFT60RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'sc35') {
    return writeSC35RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'vx170') {
    return writeVX170RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'rb15') {
    return writeRB15RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'mxt295') {
    return writeMXT295RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'h777') {
    return writeH777RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'btech') {
    return writeBTechMobileRadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'rt21') {
    return writeRT21RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'kenwood60g') {
    return writeKenwood60GRadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'tdh8') {
    return writeTDH8RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'jc8810') {
    return writeJC8810RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'ga510') {
    return writeGA510RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'rt490') {
    return writeRT490RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'bft8') {
    return writeBFT8RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'th9000') {
    return writeTH9000RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'fd268') {
    return writeFD268RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'wp970i') {
    return writeWP970IRadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'rt900') {
    return writeRT900RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'anytone778') {
    return writeAnyTone778RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'alinco-drx35') {
    return writeAlincoDRx35RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'alinco-dr735t') {
    return writeDR735TRadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'leixen') {
    return writeLeixenRadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-m60') {
    return writeKenwoodM60RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'thuv88') {
    return writeTHUV88RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'r2') {
    return writeR2RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'ft7800') {
    return writeFT7800RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'yaesu-ftx800') {
    return writeFTx800RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-tkx180') {
    return writeTKx180RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-p60') {
    return writeKenwoodP60RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'kenwood-tkx80') {
    return writeTKx80RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'lt725uv') {
    return writeLT725UVRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'kenwood-cat') {
    return writeKenwoodCatRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'icom-civ') {
    return writeIcomCivRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'anytone5888') {
    return writeAnyTone5888RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'kenwood-tkx102') {
    return writeTKx102RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'kenwood-tkx140') {
    return writeTKx140RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'kenwood-tkx160') {
    return writeTKx160RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'wouxun-classic') {
    return writeWouxunClassicRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'wouxun-kg935g') {
    return writeKG935GRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'wouxun-kguv9d') {
    return writeKGUV9DRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'radioddity-gm30') {
    return writeGM30RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'uvk5') {
    return writeUVK5RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'retevis-ra25') {
    return writeRA25RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'retevis-rt1') {
    return writeRT1RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'retevis-rt21h') {
    return writeRT21HRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'retevis-rt23') {
    return writeRT23RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'retevis-rt87') {
    return writeRT87RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'retevis-rt97s') {
    return writeRT97SRadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'retevis-rb17p') {
    return writeRB17PRadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'rugged-rh5rv2') {
    return writeRH5RV2RadioWithTransport(profile, image, transport, onProgress)
  }
  if (profile.protocol === 'yaesu-ft817') {
    return writeFT817RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'baofeng-digital') {
    return writeBaofengDigitalRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'baofeng-dm32uv') {
    return writeBaofengDM32UVRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'tid-hid') {
    return writeTIDHidRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'yaesu-ft2d') {
    return writeFT2DRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'baofeng-common') {
    return writeBaofengCommonRadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'baofeng-uvb5') {
    return writeUVB5RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'tyt-th7800') {
    return writeTH7800RadioWithTransport(
      profile,
      image,
      transport,
      onProgress,
    )
  }
  if (profile.protocol === 'tyt-thuvf8d') {
    return writeTHUVF8DRadioWithTransport(profile, image, transport, onProgress)
  }
  return writeUv17(profile, image, transport, onProgress)
}

export type WebChannelPlacement = 'end' | 'before-selected' | 'after-selected'

export function browserInsertionTarget(
  channels: readonly WebChannel[],
  placement: WebChannelPlacement,
  selected: number | null,
): number | null {
  if (channels.length === 0) return null
  const byNumber = new Map(channels.map((channel) => [channel.number, channel]))
  const minimum = Math.min(...channels.map((channel) => channel.number))
  const maximum = Math.max(...channels.map((channel) => channel.number))
  let target: number
  if (placement === 'end') {
    const populated = channels.filter((channel) => !channel.empty)
    target =
      populated.length === 0
        ? minimum
        : Math.max(...populated.map((channel) => channel.number)) + 1
  } else {
    if (selected === null) return null
    target = placement === 'before-selected' ? selected : selected + 1
  }
  if (target < minimum || target > maximum) {
    return null
  }
  return byNumber.has(target) ? target : null
}

export function browserInsertChannel(
  image: Uint8Array,
  profile: BrowserRadioProfile,
  channels: readonly WebChannel[],
  channel: WebChannel,
): Uint8Array<ArrayBuffer> {
  const next = new Uint8Array(image)
  const target = channels.find((candidate) => candidate.number === channel.number)
  if (!target) throw new Error('That channel location is not available.')
  if (!target.empty) {
    const byNumber = new Map(
      channels.map((candidate) => [candidate.number, candidate]),
    )
    let gap = target.number + 1
    const maximum = Math.max(...channels.map((candidate) => candidate.number))
    while (gap <= maximum) {
      const candidate = byNumber.get(gap)
      if (!candidate || candidate.empty) break
      gap += 1
    }
    if (gap > maximum) {
      throw new Error('No empty channel slot is available after the target.')
    }
    const moving = channels
      .filter(
        (candidate) =>
          !candidate.empty &&
          candidate.number >= target.number &&
          candidate.number < gap,
      )
      .sort((left, right) => right.number - left.number)
    for (const candidate of moving) {
      browserApplyChannel(next, profile, {
        ...candidate,
        number: candidate.number + 1,
      })
    }
  }
  browserApplyChannel(next, profile, channel)
  return next
}

export function browserMoveChannel(
  image: Uint8Array,
  profile: BrowserRadioProfile,
  channels: readonly WebChannel[],
  fromNumber: number,
  toNumber: number,
): Uint8Array<ArrayBuffer> {
  if (fromNumber === toNumber) return image.slice()
  const source = channels.find((channel) => channel.number === fromNumber)
  const target = channels.find((channel) => channel.number === toNumber)
  if (!source || source.empty || !target) {
    throw new Error('Select two available channel locations to move a channel.')
  }
  const next = new Uint8Array(image)
  browserApplyChannel(next, profile, { ...source, number: toNumber })
  if (target.empty) {
    browserApplyChannel(next, profile, {
      ...source,
      number: fromNumber,
      empty: true,
    })
  } else {
    browserApplyChannel(next, profile, { ...target, number: fromNumber })
  }
  return next
}

function chirpImage(
  profile: BrowserRadioProfile,
  image: Uint8Array,
): Uint8Array {
  if (profile.protocol === 'uv17') return createUv17Image(profile, image)
  if (profile.protocol === 'rt22') {
    const result = new Uint8Array(profile.memorySize + 8)
    result.set(image.slice(0, profile.memorySize))
    result.set(
      new TextEncoder().encode(profile.model.padEnd(8, ' ').slice(0, 8)),
      profile.memorySize,
    )
    return result
  }
  const metadata = {
    mem_extra: {},
    rclass: 'DynamicRadioAlias',
    vendor: profile.vendor,
    model:
      profile.protocol === 'ft60' || profile.protocol === 'vx170'
        ? profile.chirpModel
        : profile.model,
    variant: '',
    chirp_version: 'py3dev',
  }
  const encoded = new TextEncoder().encode(btoa(JSON.stringify(metadata)))
  const result = new Uint8Array(
    image.byteLength + CHIRP_IMAGE_MARKER.byteLength + encoded.byteLength,
  )
  result.set(image)
  result.set(CHIRP_IMAGE_MARKER, image.byteLength)
  result.set(encoded, image.byteLength + CHIRP_IMAGE_MARKER.byteLength)
  return result
}

export function browserCreateBackup(
  profile: BrowserRadioProfile,
  image: Uint8Array,
): Uint8Array {
  if (profile.protocol === 'tid-hid') return image.slice(0, profile.memorySize)
  if (profile.protocol === 'kenwood-cat' || profile.protocol === 'icom-civ') {
    return image.slice(0, profile.memorySize)
  }
  return chirpImage(profile, image)
}

export function browserExtractImage(
  profile: BrowserRadioProfile,
  bytes: Uint8Array,
): Uint8Array {
  if (profile.protocol === 'tdh8') return extractTDH8Image(profile, bytes)
  if (profile.protocol === 'uv17') return extractUv17Image(profile, bytes)
  if (
    profile.protocol === 'ft60' ||
    profile.protocol === 'sc35' ||
    profile.protocol === 'vx170' ||
    profile.protocol === 'rb15' ||
    profile.protocol === 'mxt295' ||
    profile.protocol === 'h777' ||
    profile.protocol === 'btech' ||
    profile.protocol === 'rt21' ||
    profile.protocol === 'kenwood60g' ||
    profile.protocol === 'jc8810' ||
    profile.protocol === 'ga510' ||
    profile.protocol === 'rt490' ||
    profile.protocol === 'bft8' ||
    profile.protocol === 'th9000' ||
    profile.protocol === 'fd268' ||
    profile.protocol === 'wp970i' ||
    profile.protocol === 'rt900' ||
    profile.protocol === 'anytone778' ||
    profile.protocol === 'alinco-drx35' ||
    profile.protocol === 'alinco-dr735t' ||
    profile.protocol === 'leixen' ||
    profile.protocol === 'kenwood-m60' ||
    profile.protocol === 'thuv88' ||
    profile.protocol === 'r2' ||
    profile.protocol === 'ft7800' ||
    profile.protocol === 'yaesu-ftx800' ||
    profile.protocol === 'kenwood-tkx180' ||
    profile.protocol === 'kenwood-p60' ||
    profile.protocol === 'kenwood-tkx80' ||
    profile.protocol === 'lt725uv' ||
    profile.protocol === 'kenwood-cat' ||
    profile.protocol === 'icom-civ' ||
    profile.protocol === 'anytone5888' ||
    profile.protocol === 'kenwood-tkx102' ||
    profile.protocol === 'kenwood-tkx140' ||
    profile.protocol === 'kenwood-tkx160' ||
    profile.protocol === 'wouxun-classic' ||
    profile.protocol === 'wouxun-kg935g' ||
    profile.protocol === 'wouxun-kguv9d' ||
    profile.protocol === 'radioddity-gm30' ||
    profile.protocol === 'uvk5' ||
    profile.protocol === 'retevis-ra25' ||
    profile.protocol === 'retevis-rt1' ||
    profile.protocol === 'retevis-rt21h' ||
    profile.protocol === 'retevis-rt23' ||
    profile.protocol === 'retevis-rt87' ||
    profile.protocol === 'retevis-rt97s' ||
    profile.protocol === 'retevis-rb17p' ||
    profile.protocol === 'rugged-rh5rv2' ||
    profile.protocol === 'yaesu-ft817' ||
    profile.protocol === 'baofeng-digital' ||
    profile.protocol === 'baofeng-dm32uv' ||
    profile.protocol === 'tid-hid' ||
    profile.protocol === 'baofeng-common' ||
    profile.protocol === 'baofeng-uvb5' ||
    profile.protocol === 'yaesu-ft2d' ||
    profile.protocol === 'tyt-th7800' ||
    profile.protocol === 'tyt-thuvf8d'
  ) {
    if (bytes.byteLength < profile.memorySize) {
      throw new Error(
        `This file is ${bytes.byteLength.toLocaleString()} bytes; ${profile.model} requires at least ${profile.memorySize.toLocaleString()}.`,
      )
    }
    return bytes.slice(0, profile.memorySize)
  }
  if (profile.protocol === 'rt22' || profile.protocol === 't18') {
    if (bytes.byteLength < profile.memorySize) {
      throw new Error(
        `This file is ${bytes.byteLength.toLocaleString()} bytes; ${profile.model} requires at least ${profile.memorySize.toLocaleString()}.`,
      )
    }
    return bytes.slice(0, profile.memorySize)
  }
  const mainSize = 0x1808
  const auxSize = 0x1948
  if (bytes.byteLength < mainSize) {
    throw new Error(
      `This file is ${bytes.byteLength.toLocaleString()} bytes; ${profile.model} requires at least ${mainSize.toLocaleString()}.`,
    )
  }
  return bytes.slice(0, bytes.byteLength >= auxSize ? auxSize : mainSize)
}

export function browserCompareImages(
  profile: BrowserRadioProfile,
  left: Uint8Array,
  right: Uint8Array,
): number | null {
  if (profile.protocol === 'rt22') {
    return compareImages(
      normalizeRT22ImageForComparison(left),
      normalizeRT22ImageForComparison(right),
    )
  }
  return compareImages(left, right)
}

export function browserChannelLabel(
  profile: BrowserRadioProfile,
  number: number,
): string {
  return profile.protocol === 'mxt295'
    ? mxt295ChannelLabel(number)
    : String(number)
}
